import { Injectable } from '@angular/core';
import { ToastMessage } from '../models/toast-message';
import { BaseStatefulServiceClass } from '../../classes/base-stateful-service.class';
import { ToastMessageAlertLevel } from '../enums/toast-message-alert-level.enum';

const TOAST_MESSAGE_STORAGE_KEY = 'savedToastMessage';

@Injectable({
    providedIn: 'root'
})
export class ToastMessageStateService extends BaseStatefulServiceClass<ToastMessage> {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor() {
        super();
    }

    success(message: string, persist: boolean = false) {
        this.state = {
            message,
            persist,
            level: ToastMessageAlertLevel.SUCCESS
        };
    }

    error(message: string, persist: boolean = false) {
        this.state = {
            message,
            persist,
            level: ToastMessageAlertLevel.ERROR
        };
    }

    displayMessageOnNavigate(): ToastMessage {
        const savedToastMessageObj = sessionStorage.getItem(TOAST_MESSAGE_STORAGE_KEY);
        if (!savedToastMessageObj) {
            return;
        }

        const savedToastMessage: ToastMessage = JSON.parse(savedToastMessageObj);

        if (savedToastMessage.level === ToastMessageAlertLevel.SUCCESS) {
            this.success(savedToastMessage.message);
        }

        if (savedToastMessage.level === ToastMessageAlertLevel.ERROR) {
            this.error(savedToastMessage.message);
        }

        sessionStorage.removeItem(TOAST_MESSAGE_STORAGE_KEY);
    }

    successAfterNavigate(message: string, toastMessageAlertLevel = ToastMessageAlertLevel.SUCCESS): void {
        const storedMessage: ToastMessage = {
            message,
            level: toastMessageAlertLevel,
            persist: false
        };
        sessionStorage.setItem(TOAST_MESSAGE_STORAGE_KEY, JSON.stringify(storedMessage));
    }

    errorAfterNavigate(message: string, toastMessageAlertLevel = ToastMessageAlertLevel.ERROR): void {
        const storedMessage: ToastMessage = {
            message,
            level: toastMessageAlertLevel,
            persist: false
        };
        sessionStorage.setItem(TOAST_MESSAGE_STORAGE_KEY, JSON.stringify(storedMessage));
    }
}
